export const removeSpecialChar = event => {
  const regex = /^[A-Za-z0-9 %-]$/
  if (!regex.test(event.key)) {
    event.preventDefault()
  }
}
export const removeNegativeNumber = event => {
  const regex = /^\d*\.?\d*$/
  if (!regex.test(event.key)) {
    event.preventDefault()
  }
}
export const removeCharAndSpace = event => {
  const regex = /^[A-Za-z0-9]$/
  if (!regex.test(event.key)) {
    event.preventDefault()
  }
}
export const persistPhoneNumber = event => {
  const regex = /^[\d,+]*$/
  if (!regex.test(event.key)) {
    event.preventDefault()
  }
}
export const persistAccountNumber = event => {
  const regex = /^[\d,]*$/
  if (!regex.test(event.key)) {
    event.preventDefault()
  }
}
